// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".crb-actions__popper.el-popover{padding:6px;border-radius:10px}", ""]);
// Exports
module.exports = exports;
